import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Icons from "../../common/components/Icons";
import SliderCard from "./SliderCard";
const Slider = () => {
  return (
    <div className="mt-4 relative">
      <Swiper
        loop={true}
        navigation={{
          nextEl: ".next-arrow",
          prevEl: ".prev-arrow",
        }}
        pagination={{ clickable: true, el: ".swiper-pagination" }}
        modules={[Navigation, Pagination]}
        className="mySwiper !pb-20 flex justify-center items-center">
        {[...Array(5)].map((_, index) => (
          <SwiperSlide key={index}>
            <SliderCard />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="absolute bottom-0 justify-between z-10 flex items-center gap-5 max-w-[330px] w-full left-1/2 -translate-x-1/2 mx-auto max-md:px-4">
        <div className="cursor-pointer prev-arrow flex items-center justify-center px-6 relative z-10">
          <Icons className="max-sm:scale-75" icon="swiper-left-arrow" />
        </div>
        <div className="swiper-pagination absolute !bottom-3 w-full flex justify-center !gap-2 md:!gap-5"></div>
        <div className="cursor-pointer next-arrow flex items-center justify-center px-6 relative z-10">
          <Icons className="max-sm:scale-75" icon="swiper-right-arrow" />
        </div>
      </div>
    </div>
  );
};

export default Slider;
